import * as Types from '../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const NonBenefitMapNearbyPharmacySearchTabsDocument = `
    query NonBenefitMapNearbyPharmacySearchTabs {
  nonBenefitMapNearbyPharmacySearchTabs {
    id
    name
    diagnosisType
    diagnosisTypeId
    sortTypes {
      type
      title
    }
    filters {
      type
      title
      description
      mode
      activeIconUrl
      inactiveIconUrl
      subFilters {
        type
        title
        description
        mode
        inactiveIconUrl
        activeIconUrl
      }
    }
    treatmentMedicines {
      id
      treatmentId
      name
      description
      dispensationUnits {
        isDefault
        dispensationUnit
        dispensationUnitDisplayName
        treatmentMedicineId
        treatmentMedicineUnitId
      }
      treatmentMedicineStrengths {
        treatmentMedicineStrengthId
        unit
        treatmentMedicineId
        isDefault
      }
    }
  }
}
    `;
export const useNonBenefitMapNearbyPharmacySearchTabsQuery = <
      TData = Types.NonBenefitMapNearbyPharmacySearchTabsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables,
      options?: UseQueryOptions<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, TError, TData>,
    ) =>
    useQuery<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, TError, TData>(
      variables === undefined ? ['NonBenefitMapNearbyPharmacySearchTabs'] : ['NonBenefitMapNearbyPharmacySearchTabs', variables],
      gqlFetcher<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables>(NonBenefitMapNearbyPharmacySearchTabsDocument, 'NonBenefitMapNearbyPharmacySearchTabs', variables),
      options
    );

useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = (variables?: Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables) => variables === undefined ? ['NonBenefitMapNearbyPharmacySearchTabs'] : ['NonBenefitMapNearbyPharmacySearchTabs', variables];
;

useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = (variables?: Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.NonBenefitMapNearbyPharmacySearchTabsQuery, Types.NonBenefitMapNearbyPharmacySearchTabsQueryVariables>(NonBenefitMapNearbyPharmacySearchTabsDocument, 'NonBenefitMapNearbyPharmacySearchTabs', variables, options);